/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  PrintDocInfo,
  PrintDocInfoFromJSON,
  PrintDocInfoFromJSONTyped,
  PrintDocInfoToJSON,
} from "./";

/**
 *
 * @export
 * @interface PrintDocInfoControllerResponse
 */
export interface PrintDocInfoControllerResponse {
  /**
   *
   * @type {PrintDocInfo}
   * @memberof PrintDocInfoControllerResponse
   */
  data?: PrintDocInfo;
  /**
   *
   * @type {ErrorResponse}
   * @memberof PrintDocInfoControllerResponse
   */
  error?: ErrorResponse;
}

export function PrintDocInfoControllerResponseFromJSON(json: any): PrintDocInfoControllerResponse {
  return PrintDocInfoControllerResponseFromJSONTyped(json, false);
}

export function PrintDocInfoControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PrintDocInfoControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : PrintDocInfoFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function PrintDocInfoControllerResponseToJSON(value?: PrintDocInfoControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: PrintDocInfoToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
